<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Информация для владельцев Национального медицинского страхования Республики Корея (NHIS)</h3>
            <p class="depth">
                Пациенты, застрахованные Национальным медицинским страхованием (NHIS) Республики Корея, должны принести с собой направление от местного врача и представить его в регистратуру для получения страховых пособий. В противном случае, Вам необходимо сначала обратиться к врачу в отделение Семейной медицины. <br>
                Направление действительно только для получения медицинских услуг в соответствующем отделении, указанном в заключении местного врача в выписанном направлении. <br>
                Если Вы хотите получить лечение в другом отделении, Вам необходимо принести направление с заключением врача соответствующего отделения.
            </p>
            <h4 class="bullet02">Информация для владельцев частного страхования</h4>
            <p class="depth">Пациенты, имеющие частное страхование, должны будут заплатить авансом, и затем подать заявку в частную страховую компанию на получение возмещения.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>